module.exports = __webpack_public_path__ + "img/not-available.e17fd2f.jpg";